import Subscription from "../../components/Subscription";
import useCheckToken from "../../logic/useCheckToken";

const SubscriptionPage = () => {
  useCheckToken();
  return <Subscription />;
};

export default SubscriptionPage;
